<template>
  <div class="layout-column flex ma-1"
       style="border-radius:4px;position:relative;"
       v-bind:style="{background: compColor.contentFrame}">

    <div v-bind:style="{'z-index': '4'}" class="layout-row layout-align-center-center pa-1">
      <div class="layout-row">
        <lx-btn
          classes="mr-1 text-none"
          :disabled="uploadDisabled"
          @click="startImport()"
          icon="cloud_upload"
          width="auto"
          :tooltip="$t('COMPONENT_IMPORT.UPLOAD_TOOLTIP_START_IMPORT')"
          :label="$t('COMPONENT_IMPORT.UPLOAD_LABEL_START_IMPORT')"
        ></lx-btn>
      </div>

      <!-- Warning if cancer register is not found -->

      <div class="flex ml-2 mr-4">
        <div class="py-2 px-3 layout-row layout-align-start-center flex-gt-sm-100"
             style="border:1px solid;border-radius: 9px;"
             :class="[!compColor.isInDarkMode ? 'red' + ' lighten-5 white--text ' : '']"
             :style="{'border-color': compColor.isInDarkMode ? '#E53935' : 'transparent'}"
             v-if="!userCancerRegister"
        >
          <v-icon class="mr-3" :color="'#E53935'">mdi-alert</v-icon>

          <span v-if="userIsPhysician" style="font-size: 18px;" :class="'red--text darken-1'">
            <small>{{ $t('WARNING_MISSING_CANCER_REGISTER') }}</small>
          </span>

          <span v-if="!userIsPhysician" style="font-size: 18px;" :class="'red--text darken-1'">
            <small>{{ $t('WARNING_MISSING_CANCER_REGISTER_EMPLOYEE') }}</small>
          </span>

          <v-btn :color="'#E53935'"
                 v-if="userIsPhysician"
                 dark
                 depressed
                 class="text-none ml-4"
                 style="height: 28px;"
                 @click="openAccountTab()"
          >{{ $t('COMPONENT_IMPORT.UPLOAD_BTN_TO_SETTINGS') }}</v-btn>
        </div>
      </div>
    </div>

    <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

    <div class="pa-2 flex layout-row">
      <tiny-progress-view :visible="isImportingData" text="Importiere"></tiny-progress-view>

      <fake-input-frame class="ma-3 flex layout-column"
                        :label="$t('COMPONENT_IMPORT.UPLOAD_FILE_CHOOSING.LABEL')">
        <div class="layout-column flex pa-4" @drop.prevent="addFilesByDragAndDrop" @dragover.prevent
             style="height: 100%;width: 100%;">

          <div class="pa-2 layout-column flex lx-delivery-background"
               v-bind:class="{'white' : !compColor.isInDarkMode,'blue-grey darken-3' : compColor.isInDarkMode}"
               style="border:1px dashed #526b77 !important;border-radius:10px;">

            <div class="flex layout-column layout-align-center-center px-12">
              <v-icon size="120" :color="compColor.primeColor">cloud_upload</v-icon>

              <span class="subtitle-1 font-weight-light"
                    v-bind:class="{'blue-grey--text text--darken-2': !compColor.isInDarkMode, 'blue-grey--text text--lighten-4': compColor.isInDarkMode}"
                    style="max-width: 450px;text-align:center;">{{ $t('COMPONENT_IMPORT.UPLOAD_FILE_CHOOSING.TEXT_DRAG_AND_DROP') }}</span>
              <span class="title font-weight-black blue-grey--text text--lighten-3 my-5">{{ $t('COMPONENT_IMPORT.UPLOAD_FILE_CHOOSING.OR') }}</span>

              <v-btn @click="openHiddenFileInput()" :color="compColor.primeColor" dark class="text-none">
                {{ $t('COMPONENT_IMPORT.UPLOAD_FILE_CHOOSING.TEXT_FILE_EXPLORER') }}
              </v-btn>

              <input type="file" hidden ref="hiddenFileInput" @change="addFilesByDialog" multiple/>
            </div>
          </div>
        </div>
      </fake-input-frame>

      <fake-input-frame class="ma-3 flex layout-column px-2"
                        :label="$t('COMPONENT_IMPORT.UPLOAD_TABLE.LABEL')">
        <div class="layout-column flex pa-4" style="height:100%;width:100%;">
          <div class="pa-2 layout-column flex lx-delivery-background"
               v-bind:class="{'white' : !compColor.isInDarkMode,'blue-grey darken-3' : compColor.isInDarkMode}"
               style="border:1px dashed #526b77 !important;border-radius:10px;">
            <v-simple-table class="flex transparent" fixed-header style="border: 2px solid"
                            :style="{'border-color': isDarkMode ? compColor.prime : 'black'}"
                            :dark="compColor.isInDarkMode">
              <template>
                <thead>
                  <tr>
                    <th class="text-right" style="width:75px;"></th>
                    <th class="text-left">{{ $t('COMPONENT_IMPORT.UPLOAD_TABLE.FILE_NAME') }}</th>
                    <th class="text-left">{{ $t('COMPONENT_IMPORT.UPLOAD_TABLE.FILE_SIZE') }}</th>
                    <th class="text-left">{{ $t('COMPONENT_IMPORT.UPLOAD_TABLE.FILE_TYPE') }}</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(file, index) in files" :key="index" class="blue-grey--text" :class="isDarkMode ? 'text--lighten-3':'text--darken-1'">
                    <td>
                      <v-btn text icon @click="removeFile(file._id)" title="Entfernen">
                        <v-icon :color="compColor.prime">delete_forever</v-icon>
                      </v-btn>
                    </td>
                    <td>{{ file.filename }}</td>
                    <td>{{ Math.round(file.size / 1000) }} KB</td>
                    <td>{{ file.fileType }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
      </fake-input-frame>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ImportUpload',
  data () {
    return {
      tableObj: {
        loading: false, // benutzt während des GetDatas, um eine Ladeanimation einzublenden
      },
      isImportingData: false,
      files: []
    }
  },
  created () {
    this.loadUploadedData()
  },
  computed: {
    uploadDisabled () {
      return this.files.length === 0
    },
    userCancerRegister () {
      return this.getUserCancerRegisterDetails().register_id
    },
    userIsPhysician () {
      return this.authStore.getters.userIsPhysician
    }
  },
  methods: {
    /**
     * Open tab of physician-account to edit cancer register details
     */
    openAccountTab () {
      this.addTabToStore({
        routeName: 'AccountDetails',
        options: {
          headline: 'Account',
          icon: 'mdi-account-circle'
        }
      })
    },

    openHiddenFileInput () {
      // reset file input um neue dateien hochladen zu können
      if (this.$refs.hiddenFileInput) {
        this.$refs.hiddenFileInput.value = ''
      }
      this.$refs.hiddenFileInput.click()
    },

    /**
     * wird bei onChange aufgerufen, wenn im Dateidialog Dateien ausgewählt werden
     * diese werden an Methode addFiles übergeben, wo sie zerlegt und aufbereitet werden
     */
    addFilesByDialog () {
      let file = this.$refs.hiddenFileInput
      if (file && file.files) {
        this.addFiles(file.files)
      }
    },

    /**
     * wird bei drop Event aufgerufen, wenn im Drag-and-Drop Bereich Dateien fallengelassen wurden
     * diese werden an Methode addFiles übergeben, wo sie zerlegt und aufbereitet werden
     */
    addFilesByDragAndDrop (e) {
      if (this.isImportingData) return

      this.addFiles(e.dataTransfer.files)
    },

    /**
     * zerlegt die Files Objekte des Browsers und push sie dann in das this.files Array welches die Tabelle füllt
     */
    addFiles (files) {
      if (!files) return

      // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
      ([...files]).forEach(f => {
        this.uploadFile(f)
      })
    },

    /**
     * lädt Dateien hoch
     */
    uploadFile (file) {
      this.isImportingData = true

      // prepare post request data
      let formData = new FormData()
      formData.append('file', file)

      // post input file to backend
      axios.post('/import/upload', formData)
        .then(() => {
          // reload uploaded file data
          this.loadUploadedData()
        })
        .catch((err) => {
          // show customized error notification
          if (err.response.data && err.response.data.message === 'ERROR_UNSUPPORTED_FILE_TYPE') {
            this.NotifySystem({
              type: 'error',
              title: 'Fehler beim Import',
              text: 'Der Typ der Datei <strong>' + file.name + '</strong> wird nicht unterstützt',
              duration: 10000
            })
          } else {
            this.NotifyError(err)
          }
        })
        .finally(() => {
          this.isImportingData = false
        })
    },

    /**
     * entfernt beim click auf den Papierkorb in der Tabelle die zugehörige Datei
     */
    removeFile (id) {
      if (this.tableObj.loading) return
      this.tableObj.loading = true

      // delete uploaded file by id
      this.$http.delete('/import/upload/' + id)
        .then(() => {
          // reload uploaded file data
          this.loadUploadedData()
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.tableObj.loading = false
        })
    },

    /**
     * holt die zwischengespeicherten Dateien
     */
    loadUploadedData () {
      // get uploaded files
      this.$http.get('/import/upload')
        .then(response => {
          if (response.data && Array.isArray(response.data.items)) {
            this.files = response.data.items
          }
        })
        .catch(this.NotifyError)
    },

    /**
     * import starten
     */
    startImport () {
      if (this.isImportingData) return
      this.isImportingData = true

      // start import
      this.$http.post('/import/start')
        .then(() => {
          this.files = []

          // Trigger 'checkPendingImport()' on parent
          this.$emit('check-pending-import')
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.isImportingData = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>

.lx-fake-input-frame .theme--dark.v-data-table {
  background-color: transparent !important;
}

</style>
